import SideDrawer from '../data qc/SideDrawer';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SideDrawerOverlay from '../reusable/SideDrawerOverlay';
import TranscriptSelectionDrawerContent from './TranscriptSelectionDrawerContent';

import './TranscriptSelectionSideDrawer.css';

export interface ChartData {
  title: string;
  labels: string[];
  dataSet: {
    data: number[];
    backgroundColor: string;
  };
}

interface TranscriptSelectionSideDrawerProps {
  isOpen: boolean;
  handleClose: () => void;
}

function TranscriptSelectionSideDrawer({ isOpen, handleClose }: TranscriptSelectionSideDrawerProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      {isSmallScreen ? (
        <SideDrawerOverlay isOpen={isOpen} handleClose={handleClose} anchor="right">
          <SideDrawer
            title="Demographics match"
            handleClose={handleClose}
            isOpen={isOpen}
            classes={['transcript-selection-side-drawer']}
            infoIcon={true}
          >
            <TranscriptSelectionDrawerContent />
          </SideDrawer>
        </SideDrawerOverlay>
      ) : (
        <SideDrawer
          title="Demographics match"
          handleClose={handleClose}
          isOpen={isOpen}
          classes={['transcript-selection-side-drawer']}
          infoIcon={true}
        >
          <TranscriptSelectionDrawerContent />
        </SideDrawer>
      )}
    </>
  );
}

export default TranscriptSelectionSideDrawer;
